module.exports = "https://static-www.niulinkcloud.com/_next/static/media/icon2.cb06d8fa37182f9ba9025ddfab05a39b.png";